<div cvJsfArraySection
	class="layout-section {{directiveData.cssClass}}"
	[data]="directiveData">
	<cv-schema-render-room-layout [data]="item.data" [layoutNode]="layoutNode"></cv-schema-render-room-layout>
</div>
